import { useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import TransTable from "../common/TransTable";
import _ from "lodash";
import { Box, Button, IconButton, Switch, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { setLoading, setSelectedUser, setUsers } from "../../redux/action";
import { Link, useNavigate } from "react-router-dom";
import Iconify from "../common/Iconify";
import Capsule from "../common/Capsule";
import Axios from "axios";
import { base_url } from "../backendurl/url";
import { useState } from "react";
import { Dateformater } from "../common/TransForm/dateFormater";
import editicon from "../../images/editIcon.png";
import ModalPopUp from "../../components/common/TransForm/ModalPopUp";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import { Notification } from "../common/Notification";

export default function ChangePlayerDetails() {
  const navigate = useNavigate();
  const { users } = useSelector((state) => state);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [popup, setpopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')
  const [notification,setnotification] = useState(false)
  const [userId, setUserId] = useState("");
    // Server-side pagination states
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState('');
  const [sortBy, setSortBy] = useState('');
     // ADD THIS: Server-side search state
  const [searchQuery, setSearchQuery] = useState('');

  const userTableColumns = (params) => [
    {
      key: "serial_no",
      label: "Player ID",
      align: "left",
      fontSize: "15px",
    },
    { key: "username", label: "User Name", align: "left", fontSize: "15px" },
    { key: "first_name", label: "Name", align: "left", fontSize: "15px" },
    { key: "email", label: "Email", align: "left" },
    { key: "mobile_number", label: "Mobile", align: "left", fontSize: "15px" },
       { key: "date_of_birth", label: "DOB", align: "left", fontSize: "15px", columnStyle: { minWidth: "120px", width: "120px" } },
      { key: "address_line_1", label: "Address Line 1", align: "left", fontSize: "15px", columnStyle: { minWidth: "150px", width: "150px" } },
       { key: "address_line_2", label: "Address Line 2", align: "left", fontSize: "15px", columnStyle: { minWidth: "150px", width: "150px" } },
      { key: "city", label: "City", align: "left", fontSize: "15px" },
      { key: "region", label: "Region", align: "left", fontSize: "15px" },
      { key: "country", label: "Country", align: "left", fontSize: "15px" },
      { key: "nationality", label: "Nationality", align: "left", fontSize: "15px", columnStyle: { minWidth: "120px", width: "120px" } },
    {
      key: "last_played_date",
      label: "Last Played Date",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        if (data.last_played_date == null) {
          return <Typography> N/A</Typography>;
        } else {
          return <Typography>{Dateformater(data["last_played_date"])}</Typography>;
        }
      },
    },
    {
      key: "available_tokens",
      label: "Available Token",
      align: "left",
      fontSize: "15px",
    },
    { key: "total_rounds_playing", label: "Total Pots", align: "left", fontSize: "15px" },
    {
      key: "active_rounds_playing",
      label: "Active Pots",
      align: "left",
      fontSize: "15px",
    },
    {
      key: "total_gain_loss",
      label: "Total Gain/Loss",
      align: "left",
      fontSize: "15px",
    },
    {
      key: "is_active",
      label: "Status",
      align: "center",
      fontSize: "14px",
      valueRenderer: (data) => {
        if (data.is_active == true) {
          return (
            <Capsule
              data="Active"
              bgColor="#21965333"
              color="#219653"
              sx={{ width: "130px" }}
            />
          );
        } else {
          return (
            <Capsule
              data="Inactive"
              bgColor="#87878714"
              color="#64748B"
              sx={{ width: "130px" }}
            />
          );
        }
      },
    },
    {
      key: "Status",
      label: "Actions",
      align: "center",
      valueRenderer: (data) => {
        return (
          <Box sx={{ width: "180px" }}>
            <IconButton
              sx={{
                "&:hover": {
                  // backgroundColor: 'transparent'
                  borderRadius: "12px",
                },
              }}
              onClick={() => {
                setUserId(data);
                setpopup(true);
              }}
            >
              <Typography
                sx={{
                  color: "#3C50E0",
                  display: "flex",
                  gap: 2,
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                Change Status
                <Iconify
                  icon={editicon}
                  type="image"
                  size="small"
                  color="primary.main"
                />
              </Typography>
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const getUsers = useCallback(async (page = 1, limit = 10, orderBy = '', order = '', search = '') => {
    try{
      if (!loading) {
        setLoading(true);
        
       // Build query parameters
      let queryParams = `page=${page}`;
      
      // Add sorting parameters if provided
      if (orderBy && order) {
        // queryParams += `&ordering=${order === 'desc' ? '-' : ''}${orderBy}`;
        queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;

      }
      // ADD THIS: Add search parameter if provided
        if (search && search.trim() !== '') {
          queryParams += `&search=${encodeURIComponent(search.trim())}`;
        }
        // const response = await Axios.get(
        //   `${base_url}/api/accounts/user/create?type=player`,
        //   Config
        // );
        console.log(`${base_url}/api/accounts/user/create?type=player&${queryParams}`,"Changes Player Details")
      const response = await Axios.get(`${base_url}/api/accounts/user/create?type=player&${queryParams}`, Config);

        if (response?.status == 200) {
          let no = 1;
          let data = response?.data?.results;
          data.map((item) => {
            item.serial_no = no;
            no += 1;
          });
          dispatch(setUsers(data));
        setTotalCount(response?.data?.count); // Set total count from API response

        }
        setLoading(false);
      }
    }
  catch(error){
    RefreshToken(error,setErrorMessage,setnotification)  
  }
  }, [dispatch]);

  const gotoAddUser = () => {
    navigate("add");
    dispatch(setSelectedUser({}));
  };

      // Handle pagination change from TransTable
    const handlePageChange = useCallback((page, rowsPerPage) => {
      setCurrentPage(page);
      setRowsPerPage(rowsPerPage);
      // API pages usually start from 1, but MUI pagination starts from 0
      getUsers(page + 1, rowsPerPage, sortBy, sortOrder);
    }, [sortBy, sortOrder, getUsers]);
  
    // Handle sorting change from TransTable
    const handleSortChange = useCallback((orderBy, order) => {
      setSortBy(orderBy);
      setSortOrder(order);
      // Reset to first page when sorting changes
      setCurrentPage(0);
      getUsers(1, rowsPerPage, orderBy, order);
    }, [rowsPerPage, getUsers]);

        // ADD THIS: Handle search from TransTable
      const handleSearch = useCallback((searchValue) => {
        setSearchQuery(searchValue);
        // Reset to first page when searching
        setCurrentPage(0);
        getUsers(1, rowsPerPage, sortBy, sortOrder, searchValue);
      }, [rowsPerPage, sortBy, sortOrder, getUsers]);
  

  const userNamediv = () => {
    return (
      <>
        Are you sure, you want to {userId.is_active ? "deactivate" : "activate"} <b>{userId?.username} </b> ?
      </>
    );
  };
  const deactiveUser = async () => {

    try{
      const response = await Axios.put(
        `${base_url}/api/accounts/user/${userId.id}`,
        { ...userId, is_active: userId.is_active ? false : true },
        Config
      );
      if (response?.data?.status == "Success") {
        navigate(-1);
      }
    }
    catch(error){
      RefreshToken(error,setErrorMessage,setnotification)  
    }
  };

  // useEffect(() => {
  //   getUsers();
  // }, []);
    useEffect(() => {
    getUsers(1, 10); // Initial load
  }, []);

  return (
    <>
      <Box>
        <TransTable
          pageTitle="Change Player Status"
          showAddBtn={false}
          // addBtnTitle = 'Change Status'
          showSearch={true}
          selecteable={false}
          checkbox={false}
          columns={userTableColumns()}
          rows={users}
          filter_keys={["username", "mobile_number", "email", "is_active"]}
          addBtnAction={gotoAddUser}
            // Server-side pagination props
          serverSide={true}
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
          // ADD THIS: Pass search handler to TransTable
          onSearch={handleSearch}
          searchQuery={searchQuery}
        />
         <Notification
        message={errorMessage}
        setopen={setnotification}
        type={"error"}
        show={notification}
      />
      </Box>
      <ModalPopUp
        setPopup={setpopup}
        openpopup={popup}
        title={userId.is_active ? "Deactivating User ? " : "Activating User ?"}
        subTitle={userNamediv()}
        textArea={true}
        saveBtnBg={"red"}
        onClick={deactiveUser}
        save={userId.is_active ? "Deactivate" : "Activate"}
        cancel={"Exit"}
      />

      <Button></Button>
    </>
  );
}
